export default {
	state: {
		contratacaoSeg: {}
	},
	getters: {
		"contratacaoSeg": state => state.contratacaoSeg
	},
	mutations: {
		setContratacaoSeg(state, payload) {
			state.contratacaoSeg = payload
		}
	},
	actions: {
		atualizarEstadoContratacaoSeg({ commit }, payload) {
			commit('setContratacaoSeg', payload)
		}
	}
};